import './styles/app-theme.css';
import './styles/markdown-reader.css';
import './components/app-root/app-root';

console.log('Portfolio.v3 initialized: Geireann Lindfield Roberts (4-File Component Pattern)');
